import type { ArrivalSource } from '@/features/auth/arrival';
import { request } from '@/lib/api/http';
import { candidateRecordSchema, messageSchema, tokenObjectSchema } from '@/lib/api/schemas';

export interface SignUpInput {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  /** Asked later in the questionnaire; the service accepts an account without it. */
  zipCode?: string;
  password: string;
  /** true when the applicant does NOT want job e-mails (the checkbox is inverted). */
  massMailOptOut: boolean;
  jobId: number | null;
  /** Which job board sent the applicant (`?source=`); null for a direct sign-up. */
  source: ArrivalSource | null;
}

export function signUp(input: SignUpInput) {
  return request('/auth/create', {
    method: 'POST',
    auth: false,
    body: input,
    schema: tokenObjectSchema,
  });
}

export function login(
  username: string,
  password: string,
  jobId: number | null,
  source: ArrivalSource | null,
) {
  const form = new FormData();
  form.set('username', username);
  form.set('password', password);
  if (jobId != null) form.set('jobId', String(jobId));
  if (source != null) form.set('source', source);
  return request('/auth/login', {
    method: 'POST',
    auth: false,
    body: form,
    schema: tokenObjectSchema,
  });
}

export function me() {
  return request('/auth/me', { schema: candidateRecordSchema });
}

export function requestPasswordReset(email: string) {
  return request('/auth/forgot/request', { auth: false, query: { email }, schema: messageSchema });
}

export function completePasswordReset(key: string, password: string) {
  return request('/auth/forgot/verify', {
    method: 'POST',
    auth: false,
    body: { key, password },
    schema: tokenObjectSchema,
  });
}

export function changePassword(oldPassword: string, password: string) {
  return request('/auth/update/password', {
    method: 'POST',
    body: { oldPassword, password },
    schema: messageSchema,
  });
}
